module.exports = __webpack_public_path__ + "static/media/no-starch-logo.b319d614.png";